import React, { useState, useEffect } from 'react';
import { FiDownload } from 'react-icons/fi'; // npm install react-icons
import '../../styles//crud.css';
import '../../styles//botones_dflt.css';
import Spinner from "../spinner";
import { convertFileToBase64, descargarDocumentoClientePotencial, convertirFechaParaInputDate } from '../../functions/fileFunctions.js';
import * as apiTiposDocumentos from '../../services/apiTiposDocumentos.js';
import { cargarCompanias } from '../../services/apiCompanias.js';
import { cargarClientes, obtenerCliente, listarDocumentos, eliminarCliente, eliminarTelefono, eliminarCorreo, eliminarDocumento, crearCliente, actualizarCliente } from '../../services/apiClientesPotenciales.js';
import * as apiClientes from '../../services/apiClientesPotenciales.js';
import Filtros from "../filters/filtros_clientes_potenciales.js"; 
import * as alerts from '../../functions/alerts.js';



const CrudTable = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // Estado para almacenar filas
  const [formData, setFormData] = useState({ nombre: '' ,apellido: '',direccion: '', identificacion: '', telefonos: '', correos: '',fecha_vencimiento: ''}); // Estado del formulario
  const [telefonos, setTelefonos] = useState([]); // Estado para almacenar filas
  const [correos, setCorreos] = useState([]); // Estado para almacenar filas
  const [documentos, setDocumentos] = useState([]); // Estado para almacenar filas
  const [isFormModalOpen, setIsFormModalOpen] = useState(false); // Control del modal de ingreso/edición
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Control del modal de eliminación
  const [deleteIndex, setDeleteIndex] = useState(null); // Índice de la fila a eliminar
  const [isEditing, setIsEditing] = useState(false); // Estado para editar
  const [editIndex, setEditIndex] = useState(null); // Índice de la fila a editar
  const [tipoDocOptions, setTipoDocOptions] = useState([]);
  const [tipoCompOptions, settipoCompOptions] = useState([]);

    // Cargar datos desde la API al montar el componente
    const fetchData = async (filtros) => {
      try{  
        const json = await cargarClientes(filtros);
        if (json.clientes.length>0){
            const formattedData = json.clientes.map((item) => ({
            id: item.id,
            nombre: item.nombre,
            apellido: item.apellido,
            identificacion: item.cedula_ruc,
            direccion: item.direccion,
            observaciones: item.observaciones,
            fecha_vencimiento: convertirFechaParaInputDate(item.fecha_vencimiento)
            }));
            setData(formattedData);
            
        }else{
            setData({});
        }
            setLoading(false);
        } catch (error) {
          console.error('Error al cargar los datos:', error);
      }
    };

  const storedUser = JSON.parse(localStorage.getItem("user"));


  useEffect(() => {
      fetchData({});
    }, []);

  // Manejar los cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Abrir el modal de formulario para agregar o editar
  const openFormModal = async (index = null) => {
    const jsonTipoDoc = await apiTiposDocumentos.cargarTiposDocumentos(4);
    if(jsonTipoDoc){
        const tipoDoc = jsonTipoDoc.tiposDocs.map((item) => ({
        id: item.id,
        tipo: item.tipo
        }));
        setTipoDocOptions(tipoDoc);
    }
    const jsonDocCompania = await cargarCompanias();
    if(jsonDocCompania){
        const compDoc = jsonDocCompania.companias.map((item) => ({
        id: item.id,
        nombre: item.nombre
        }));
        settipoCompOptions(compDoc);
    }
    if (index !== null) {
      try {
        const jsonCli = await obtenerCliente(data[index].id);
        if(jsonCli){
          const formattedData = ({
            id: jsonCli.id,
            nombre: jsonCli.nombre,
            apellido: jsonCli.apellido,
            identificacion: jsonCli.cedula_ruc,
            direccion: jsonCli.direccion,
            observaciones: jsonCli.observaciones,
            fecha_vencimiento: convertirFechaParaInputDate(jsonCli.fecha_vencimiento)
          });
          setFormData(formattedData);
          setTelefonos(jsonCli.telefonos);
          setCorreos(jsonCli.correos);
          const jsonDoc = await listarDocumentos(data[index].id);
          setDocumentos(Array.isArray(jsonDoc) ? jsonDoc : []);
        }
      } catch (error) {
        console.error('Error al cargar los datos:', error);
      }
      //setFormData(data[index]);  Cargar datos existentes si es edición
      setIsEditing(true);
      setEditIndex(data[index].id);
    } else {
      setFormData({ nombre: '' ,apellido: '',direccion: '', identificacion: '', telefonos: '', correos: '', fecha_vencimiento: ''}); 
      setTelefonos([]);
      setCorreos([]);
      setDocumentos([]);
      setIsEditing(false);
    }

    setIsFormModalOpen(true);
  };

  // Cerrar el modal de formulario
  const closeFormModal = () => {
    fetchData({});
    setIsFormModalOpen(false);
  };

  // Guardar datos (Agregar o Editar)
  async function handleFormSubmit(e) {
    e.preventDefault();
    if (isEditing) {
      try {
        const response = await actualizarCliente(formData, storedUser, editIndex);
        if (response.ok) {
          const nuevosTelefonos = telefonos.filter((elemento) => !elemento.id);
          const resultados = await Promise.all(
            nuevosTelefonos.map((elemento) => { 
              return apiClientes.agregarTelefono(elemento, editIndex, storedUser);  
            })
          );
          resultados.forEach((response) => {
            if (!response.ok) {
              console.error('Error al crear teléfono:', response.statusText);
            }
          });
          const telefonosExistentes = telefonos.filter((elemento) => elemento.id);
          const resultados_upd_telf = await Promise.all(
            telefonosExistentes.map((elemento) => { 
              return apiClientes.actualizarTelefono(elemento, storedUser);  
            })
          );
          resultados_upd_telf.forEach((response) => {
            if (!response.ok) {
              console.error('Error al editar el teléfono:', response.statusText);
            }
          });
          const nuevosCorreos = correos.filter((elemento) => !elemento.id);
          const resultados_add_corr = await Promise.all(
            nuevosCorreos.map((elemento) => { 
              return apiClientes.agregarCorreo(elemento, editIndex,storedUser);  
            })
          );
          resultados_add_corr.forEach((response) => {
            if (!response.ok) {
              console.error('Error al agregar el correo:', response.statusText);
            }
          });
          const correosExistentes = correos.filter((elemento) => elemento.id);
          const resultados_upd_corr = await Promise.all(
            correosExistentes.map((elemento) => { 
              return apiClientes.actualizarCorreo(elemento, storedUser);  
            })
          );
          resultados_upd_corr.forEach((response) => {
            if (!response.ok) {
              console.error('Error al editar el correo:', response.statusText);
            }
          });
          const nuevosDocumentos = documentos.filter((elemento) => !elemento.id);
          const resultados_add_doc = await Promise.all(
            nuevosDocumentos.map((elemento) => { 
              return apiClientes.agregarDocumento(elemento, editIndex, storedUser);  
            })
          );
          resultados_add_doc.forEach((response) => {
            if (!response.ok) {
              console.error('Error al agregar el documento:', response.statusText);
            }
          });
          const documentosExistentes = documentos.filter((elemento) => elemento.id && elemento.bandera === "modificado");
          const resultados_upd_doc = await Promise.all(
            documentosExistentes.map((elemento) => { 
              return apiClientes.actualizarDocumento(elemento, storedUser);  
            })
          );
          resultados_upd_doc.forEach((response) => {
            if (!response.ok) {
              console.error('Error al editar el documento:', response.statusText);
            }
          });
          alerts.handleSuccess('Éxito!','Cambios guardados correctamente')
        } else {
          console.error('Error al guardar cambios:', response.statusText);
        }
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
    } else {
      const response = await crearCliente(formData, telefonos, correos, storedUser);
      if (response.ok) {
        const data = await response.json();
        const nuevoCliente=data.cliente_id;
        const nuevosDocumentos = documentos.filter((elemento) => !elemento.id);
        const resultados_add_doc = await Promise.all(
          nuevosDocumentos.map((elemento) => { 
            return apiClientes.agregarDocumento(elemento, nuevoCliente, storedUser);  
          })
        );
        resultados_add_doc.forEach((response) => {
          if (!response.ok) {
            console.error('Error al agregar el documento:', response.statusText);
          }
        });
        alerts.handleSuccess('Éxito!','Cliente creado correctamente')
        setIsFormModalOpen(false);
      } else {
        console.error('Error al crear nuevo cliente:', response.statusText);
      }
    }
    closeFormModal();
  }

  const handleChangeTelf = (index, field, value) => {
    const nuevosTelefonos = [...telefonos];
    nuevosTelefonos[index][field] = value; // Actualiza el campo específico
    setTelefonos(nuevosTelefonos);
  };

  const handleChangeCorr = (index, field, value) => {
    const nuevosCorreos = [...correos];
    nuevosCorreos[index][field] = value; // Actualiza el campo específico
    setCorreos(nuevosCorreos);
  };

  const handleChangeDoc = async (event,index) => {
    const file = event.target.files[0];
    const nuevosDocumentos = [...documentos];
    if (!file) return;
    const nombre_ = file.name;
    const extension_ = file.name.split('.').pop();
    const contenido_ = await convertFileToBase64(file);
    nuevosDocumentos[index]["nombre"]=nombre_;
    nuevosDocumentos[index]["extension"]=extension_;
    nuevosDocumentos[index]["contenido"]=contenido_;
    nuevosDocumentos[index]["bandera"]="modificado";
    setDocumentos(nuevosDocumentos);
  };

  const handleChangeTipoDoc = (index, e) => {
    const updatedDocuments = [...documentos];
    updatedDocuments[index].tipo = e.target.value;
    setDocumentos(updatedDocuments);
  };

  const handleChangeCompania = (index, e) => {
    const updatedDocuments = [...documentos];
    updatedDocuments[index].id_compania = e.target.value;
    updatedDocuments[index]["bandera"]="modificado";
    setDocumentos(updatedDocuments);
  };

  const openDeleteModal = (index) => {
    setDeleteIndex(index);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const cambiarCliente = async () => {
    const response = await apiClientes.cambiarCliente(formData,storedUser);
    if (response.ok) {
      alerts.handleSuccess('Éxito!','Estado actualizado correctamente')
    } else {
      console.error('Error al actualizar el estado del cliente:', response.statusText);
    }
    fetchData({});
    closeFormModal();
  };

  const confirmDelete = async () => {
    const response = await eliminarCliente(data[deleteIndex].id,storedUser);
    if (response.ok) {
      alerts.handleSuccess('Éxito!','Cliente eliminado correctamente')
    } else {
      console.error('Error al eliminar el usuario:', response.statusText);
    }
    fetchData({});
    closeDeleteModal();
  };

  const handleDeleteTelf = async (index) => {
    if (telefonos[index].id){
        const response = await eliminarTelefono(telefonos[index].id,storedUser)
        if (response.ok) {
          alerts.handleSuccess('Éxito!','Telefono eliminado correctamente')
        } else {
          console.error('Error al eliminar el telefono:', response.statusText);
        }
    }
    setTelefonos((prevTelefonos) => prevTelefonos.filter((_, i) => i !== index));        
  };

  const agregarTelefono = () => {
    setTelefonos([...telefonos, { telefono: "", descripcion: "" }]);
  };

  const handleDeleteCorr = async (index) => {
    if (correos[index].id){
        const response = await eliminarCorreo(correos[index].id,storedUser)
        if (response.ok) {
          alerts.handleSuccess('Éxito!','Correo eliminado correctamente')
        } else {
          console.error('Error al eliminar el correo:', response.statusText);
        }
    }
    setCorreos((prevCorreos) => prevCorreos.filter((_, i) => i !== index));        
  };

  const agregarCorreo = () => {
    setCorreos([...correos, { correo: "", descripcion: "" }]);
  };

  const handleDeleteDoc = async (index) => {
    if (documentos[index].id){
        const response = await eliminarDocumento(documentos[index].id,storedUser)
        if (response.ok) {
          alerts.handleSuccess('Éxito!','Documento eliminado correctamente')
        } else {
          console.error('Error al eliminar el correo:', response.statusText);
        }
    }
    setDocumentos((prevDocumentos) => prevDocumentos.filter((_, i) => i !== index));        
  };

  const agregarDocumento = () => {
    setDocumentos([...documentos, {tipo: "1" , nombre: "", bandera: "nuevo", extension: "", contenido: "", id_compania: 0 ,}]);
  };

  return (
  <>
    <div>
      <Filtros onBuscar={fetchData}/>
    </div>
    <div className="crud-table">
      {!loading && <button className='button_new' onClick={() => openFormModal()}>Añadir Nuevo Cliente Potencial</button>}
      {/* Tabla */}
      {loading ? <Spinner /> :
      <table>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>Identificación</th>
            <th>Fecha Vencimiento</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item.id}>
                <td>{item.nombre}</td>
                <td>{item.apellido}</td>
                <td>{item.identificacion}</td>
                <td>{item.fecha_vencimiento}</td>
                <td>
                  <button className="editar" onClick={() => openFormModal(index)}>Editar</button>
                  <button className="eliminar" onClick={() => openDeleteModal(index)}>Eliminar</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No hay datos</td>
            </tr>
          )}
        </tbody>
      </table>
      }
      {/* Modal de Formulario */}
      {isFormModalOpen && (
        <div className="modal">
          <div className="modal-content modal-content-wide">
            <h2>{isEditing ? 'Editar Cliente Potencial' : 'Añadir Cliente Potencial'}</h2>
            <table>
              <tbody>
                <tr>
                  <td className='modal-region'>
                    <h3>Información General</h3>
                    <form onSubmit={handleFormSubmit} className='form_crud'>
                      <input
                        type="text"
                        name="nombre"
                        placeholder="Nombres Cliente"
                        value={formData.nombre}
                        onChange={handleChange}
                        required
                      />
                      <input
                        type="text"
                        name="apellido"
                        placeholder="Apellidos Cliente"
                        value={formData.apellido}
                        onChange={handleChange}
                        required
                      />
                      <input
                        type="text"
                        name="direccion"
                        placeholder="Dirección"
                        value={formData.direccion}
                        onChange={handleChange}
                        required
                      />
                      <input
                        type="text"
                        name="identificacion"
                        placeholder="Identificación"
                        value={formData.identificacion}
                        onChange={handleChange}
                        required
                      />
                      <input
                        type="date"
                        name="fecha_vencimiento"
                        placeholder="Fecha Vencimiento"
                        value={formData.fecha_vencimiento}
                        onChange={handleChange}
                        required
                      />
                    <textarea
                        name="observaciones"
                        placeholder="Observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        rows={6} // Puedes ajustar el número de líneas visibles
                        style={{ width: '100%' }} // O define un ancho específico si deseas
                        required
                      />
                    </form>
                  </td>
                  <td className='modal-region'>
                  <button className='button_new' onClick={agregarTelefono}>Añadir Teléfono</button>
                    {/* Tabla Telefonos */}
                  
                    {telefonos.length > 0 && (
                          <table >
                          <tbody>
                              {telefonos.map((telefono, index) => (
                              <tr key={index}>
                                  <td>
                                  <input
                                      type="text"
                                      id="telefono"
                                      name="telefono"
                                      value={telefono.telefono}
                                      onChange={(e) => handleChangeTelf(index, "telefono", e.target.value)}
                                      placeholder="Teléfono"
                                  />
                                  </td>
                                  <td><input
                                      type="text"
                                      id="descripcion"
                                      name="descripcion"
                                      value={telefono.descripcion}
                                      onChange={(e) => handleChangeTelf(index, "descripcion", e.target.value)}
                                      placeholder="Descripción"
                                  /></td>
                                  <td>
                                  <button onClick={() => handleDeleteTelf(index)}>X</button>
                                  </td>
                              </tr>
                              ))}
                          </tbody>
                          </table>  
                    )}
                  </td>
                  </tr>
                  <tr>
                  <td className='modal-region'>
                    <button className='button_new' onClick={agregarCorreo}>Añadir Correo</button>
                    {/* Tabla Correos */}
                    {correos.length > 0 && (
                        <table >
                        <tbody>
                            {correos.map((correos, index) => (
                            <tr key={index}>
                                <td>
                                <input
                                    type="text"
                                    id="correos"
                                    name="correos"
                                    value={correos.correo}
                                    onChange={(e) => handleChangeCorr(index, "correo", e.target.value)}
                                    placeholder="Correo"
                                />
                                </td>
                                <td><input
                                    type="text"
                                    id="descripcion"
                                    name="descripcion"
                                    value={correos.descripcion}
                                    onChange={(e) => handleChangeCorr(index, "descripcion", e.target.value)}
                                    placeholder="Descripción"
                                /></td>
                                <td>
                                <button onClick={() => handleDeleteCorr(index)}>X</button>
                                </td>
                            </tr>
                            ))}
                        </tbody>
                        </table>  
                    )}
                  </td>
                  <td className='modal-region'>
                    <button className='button_new' onClick={agregarDocumento}>Añadir Documento</button>
                    {/* Tabla Documentos */}
                    {documentos.length > 0 && (
                        <table >
                        <tbody>
                            {documentos.map((documentos, index) => (
                            <tr key={index}>
                                <td>
                                <select id="options"
                                    type="text"
                                    name="tipo"
                                    placeholder="Tipo Documento"
                                    value='1'
                                    onChange={(e) => handleChangeTipoDoc(index, e)}
                                    required
                                    disabled
                                  >
                                    {tipoDocOptions.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.tipo}
                                    </option>
                                    ))}
                                  </select>
                                </td>
                                <td>
                                <select id="options"
                                    type="text"
                                    name="compania"
                                    placeholder="Companía"
                                    value={documentos.id_compania}
                                    onChange={(e) => handleChangeCompania(index, e)}
                                    required
                                    disabled={documentos.id}
                                  > <option key='-1' value='-1'>- Seleccione -</option>
                                    {tipoCompOptions.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.nombre}
                                    </option>
                                    ))}
                                  </select>
                                </td>
                                <td>
                                <input
                                  id="archivo"
                                  type="file"
                                  name="archivo"
                                  placeholder="Elija el archivo a cargar"
                                  onChange={(event) => handleChangeDoc(event, index)}
                                  required
                                />
                                </td>
                                <td>
                                {documentos.id ? (
                                      <button onClick={() => descargarDocumentoClientePotencial(documentos.id)}
                                        style={{ textDecoration: 'none', color: 'black', background: 'none' }}
                                      >
                                        <FiDownload size={30}/>
                                      </button>
                                      ):(null)
                                }
                                </td>
                                <td>
                                <button onClick={() => handleDeleteDoc(index)}>X</button>
                                </td>
                            </tr>
                            ))}
                        </tbody>
                        </table>  
                    )}
                  </td>                                    
                  </tr>
                </tbody>
            </table>
            <button className='amplio' onClick={cambiarCliente}>Cambiar Cliente</button>
            <button type="submit" className='guardar' onClick={handleFormSubmit}>{isEditing ? 'Actualizar' : 'Añadir'}</button>
            <button type="button" className='cancelar' onClick={closeFormModal}>Cancelar</button>
          </div>
        </div>
      )}

      {/* Modal de Confirmación de Eliminación */}
      {isDeleteModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Confirmar Eliminación</h2>
            <p>¿Estás seguro de que deseas eliminar este registro?</p>
            <button onClick={confirmDelete}>Sí, eliminar</button>
            <button onClick={closeDeleteModal}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  </>
  );
};

export default CrudTable;